import React, {
  useState,
} from 'react';

import {
  Flex,
} from 'web-styled';

import Fold from './Fold';

type Props = {
  contents: any[];
  initialActive: number;
};

const Accordion = ({ contents, initialActive }: Props) => {
  const [active, setActive] = useState<number>(initialActive);

  /**
  * Selects the given fold,
  * and deselects if it has been clicked again by setting "active to -1"
  * */
  const selectFold = (foldNum: number) => {
    setActive(
      (prevState) => (prevState === foldNum ? -1 : foldNum),
    );
  };

  return (
    <Flex width="100%" column>
      {contents.map((content, i) => (
        <Fold
          key={`${i.toString()}-${content.title}`}
          active={i === active}
          content={content}
          onToggle={() => selectFold(i)}
        />
      ))}
    </Flex>
  );
};

export default Accordion;
